module.exports = __webpack_public_path__ + "img/3-Expo Metals.dade9e74.png";